import React from 'react'

const FeedOrder = () => (
  <svg width="6px" height="14px" viewBox="0 0 6 14" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="order" transform="translate(-4.000000, 0.000000)">
        <rect id="holder" x="0" y="0" width="14" height="14" />
        <path
          d="M7.4,13.1557143 L7.4,1.19 L9.50285714,3.29285714 C9.57142857,3.36142857 9.66,3.39571429 9.75142857,3.39571429 C9.84285714,3.39571429 9.93142857,3.36142857 10,3.29285714 C10.1371429,3.15571429 10.1371429,2.93571429 10,2.79857143 L7.3,0.0985714286 C7.16857143,-0.0328571429 6.93714286,-0.0328571429 6.80571429,0.0985714286 L4.10285714,2.79857143 C3.96571429,2.93571429 3.96571429,3.15571429 4.10285714,3.29285714 C4.24,3.43 4.46,3.43 4.59714286,3.29285714 L6.7,1.19 L6.7,13.1557143 C6.7,13.35 6.85714286,13.5071429 7.05142857,13.5071429 C7.24285714,13.5042857 7.4,13.3471429 7.4,13.1557143 Z"
          id="Shape"
          fill="#000000"
          fillRule="nonzero"
        />
      </g>
    </g>
  </svg>
)

export default FeedOrder
